// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 231 ? "checkout" : chunkId) + "." + {"231":"d8ef4876","324":"ef9c4ebc"}[chunkId] + ".css";
};